module.exports = __webpack_public_path__ + "static/media/ic_Kurento_Monitoring_Server.c97cfde4.svg";